module.exports = __webpack_public_path__ + "static/media/female.ef4421f0.png";